:root{
  --ON: initial;
  --OFF: ;
}

.theme-default,
.theme-dark {
  --light: var(--OFF);
  --dark: var(--ON);
}

.theme-light {
  --light: var(--ON);
  --dark: var(--OFF);
}

@media (prefers-color-scheme: light) {
  .theme-default {
    --light: var(--ON);
    --dark: var(--OFF);
  }
}

:root{
  --font-size-reset: .625em;
  --font-size: 1.8rem;
  --font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji";
  --line-height: 1.5;

  --blue: #0157FF;
  --navy: #18007A;
  --green: #00D900;
  --lime: #CBFF01;
  --light-grey: #F1F1F1;
  --white: #ffffff;
  --black: #000000;

  --color: var(--light, #000000) var(--dark, #ffffff);
  --background: var(--light, #F1F1F1) var(--dark, #003ec7);

  --theme-color: var(--light, #3aeb16) var(--dark, #3aeb16);
  --theme-layer-background: var(--light, rgba(0, 0, 0, 0.14)) var(--dark, rgba(255, 255, 255, 0.2));

  --drawer-background: var(--light, #ffffff) var(--dark, #3365D2);
  --drawer-color: var(--light, #000000) var(--dark, #ffffff);

}
